'use strict';
module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/engine-user-agent.js
// module id = 103
// module chunks = 0